import { ReactNode } from 'react'

import { Select } from '../../../Select'
import { StopLoss, StopLossField } from '../../model'
import { Disclosure } from '../Disclosure'

import s from './styles.module.scss'

export const StopLossFields = ({
  input,
  inputHint,
  stopLossField,
  onOpenChange,
  stopLossType,
  onStopLossFieldChange,
  onStopLossTypeChange,
}: {
  input?: ReactNode
  inputHint?: ReactNode
  stopLossField: StopLossField
  onOpenChange: (val: boolean) => void
  stopLossType: StopLoss | null
  onStopLossTypeChange?: (value: StopLoss) => void
  onStopLossFieldChange?: (value: StopLossField) => void
}) => (
  <Disclosure title="Stop loss" isOpen={!!stopLossType} onChange={onOpenChange}>
    <Select
      value={stopLossType}
      onChange={onStopLossTypeChange}
      placeholder="Select"
      options={[
        { name: 'Normal', value: StopLoss.Normal },
        { name: 'Trailing', value: StopLoss.Trailing },
        { name: 'Guaranteed', value: StopLoss.Guaranteed },
      ]}
    />
    {stopLossType !== StopLoss.Trailing ? (
      <Select
        value={stopLossField}
        onChange={onStopLossFieldChange}
        placeholder="Select"
        options={[
          { name: 'Amount', value: 'stop_loss_amount', subname: 'Close if lose is' },
          { name: 'Distance', value: 'stop_loss_distance', subname: 'Close if price goes down by' },
          { name: 'Price level', value: 'stop_loss_level', subname: 'Close when price is' },
        ]}
      />
    ) : (
      <span className={s.distanceExplanation}>Distance</span>
    )}
    <div className={s.inputContainer}>{input}</div>

    {inputHint}
  </Disclosure>
)
